import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { setCloseAnalyticsModal } from "../../redux/features/Analytics/analyticsSlice";

function AnalyticsModal() {
  const dispatch: any = useDispatch();
  // const { orderDetailsModal, orderDetailsData } = useSelector((state: any) => state.sharedActions);
  const states = useSelector((state: any) => state.analyticsSlice);
  const [filteredOrders, setFilteredOrders] = useState(states.modalData);
  const [dateRange, setDateRange] = useState({ from: "", to: "" });

  console.log(states.modalData,">>> modal Data >>>>")

  const closeModal = () => {
    dispatch(setCloseAnalyticsModal());
    setDateRange({ from: "", to: "" });
  };

  useEffect(() => {
    if (dateRange.from && dateRange.to) {
      const fromDate = new Date(dateRange.from);
      const toDate = new Date(dateRange.to);
      const filtered = states.modalData.filter((order: any) => {
        const orderDate = new Date(order.created_at);
        return orderDate >= fromDate && orderDate <= toDate;
      });
      setFilteredOrders(filtered);
    } else {
      setFilteredOrders(states.modalData);
    }
  }, [dateRange, states.modalData]);

  const columns = [
    {
      name: "Order ID",
      selector: (row: any) => row.order_id,
      sortable: true,
    },
    {
      name: "Order Name",
      selector: (row: any) => row.order_name,
      sortable: true,
    },
    {
      name: "SKU",
      selector: (row: any) => row.sku,
    },
    {
      name: "Total Amount",
      selector: (row: any) => `${row.total_amount.toFixed(2)}`,
    },
    {
      name: "Margin",
      selector: (row: any) => `${row.margin.toFixed(2)}`,
    },
    {
      name: "Customer Email",
      selector: (row: any) => row.customer_email,
    },
    {
      name: "Created At",
      selector: (row: any) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
  ];

  return (
    <Modal
      className="wrapmodal"
      backdrop="static"
      size="xl"
      show={states.openAnalyticsModal}
      onHide={closeModal}
      animation={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Order Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <div className="row mb-3">
          <div className="col-md-3">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={dateRange.from}
              onChange={(e) => setDateRange({ ...dateRange, from: e.target.value })}
            />
          </div>
          <div className="col-md-3">
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              value={dateRange.to}
              onChange={(e) => setDateRange({ ...dateRange, to: e.target.value })}
            />
          </div>
        </div> */}
        <DataTable
          columns={columns}
          data={filteredOrders}
          pagination
          highlightOnHover
          striped
          responsive
          noDataComponent="No orders available for selected date range."
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export { AnalyticsModal };
